import {
  FlexColumn,
  FlexContainer,
} from '@editor/components/utilities/layouts';
import { P4 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const LeftColumnInterval = styled(FlexColumn)`
  width: 100%;
  padding: 2px;
  flex-grow: 2;

  ${QUERIES.largeTabletAndUp} {
    padding: 32px;
    width: 336px;
  }
`;

export const TeamComponent = styled(FlexColumn)`
  padding-top: 24px;
`;

export const LeftColumnPayment = styled(FlexColumn)`
  width: 100%;
  gap: 16px;
  padding: 24px 2px;
  box-shadow: ${themeStyle.shadowMedium};

  ${QUERIES.largeTabletAndUp} {
    padding: 24px 32px;
    width: 336px;
  }
`;

export const RightColumn = styled(FlexColumn)`
  background: ${themeStyle.backgroundBase};

  html[data-theme='dark'] &&,
  .dark && {
    background: ${themeStyle.darkBackgroundBase};
  }
`;

export const RightColumnTrial = styled(RightColumn)`
  padding: 114px 32px 24px 32px;
`;

export const RightColumnTrialExplanation = styled(FlexContainer)`
  flex-grow: 2;
`;

export const RightColumnNonTrial = styled(RightColumn)`
  padding: 32px;
`;

export const RightColumnPlanDetails = styled(FlexColumn)`
  background: ${themeStyle.backgroundAlt};
  border-radius: ${themeStyle.radiusLarge};
  padding: 32px;
  height: 100%;
  border: 1px solid ${themeStyle.varInkLight};

  html[data-theme='dark'] &&,
  .dark && {
    background: ${themeStyle.darkBackgroundAlt};
  }
`;

export const PricingPlansContainer = styled(FlexColumn)`
  padding: 2px;
  overflow-y: scroll;

  ${QUERIES.largeTabletAndUp} {
    padding: 32px 32px 0px;
  }
`;

export const PricingPlan = styled(FlexColumn)<{
  businessPlanIsEnabled: boolean;
}>`
  flex-direction: column-reverse;

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: ${({ businessPlanIsEnabled }) =>
      businessPlanIsEnabled ? 'repeat(3, 292px)' : 'repeat(2, 368px)'};
    gap: 24px;
  }
`;

export const PaymentMethodWrapper = styled(FlexColumn)`
  width: 100%;
  padding: 2px;
  padding-bottom: 32px;
  min-height: 0;
  flex-grow: 1;
  overflow-y: auto;

  ${QUERIES.largeTabletAndUp} {
    width: 336px;
    padding: 32px 16px 16px 32px;
  }
`;

export const PaymentMethodOption = styled(FlexColumn)`
  padding-right: 10px;

  ${QUERIES.largeTabletAndUp} {
    padding-right: 20px;
  }
`;

export const PaymentMethodTitle = styled(P4)`
  padding-bottom: 2px;
  font-weight: normal;
`;

export const PaymentBottomSection = styled(FlexColumn)`
  background: var(--color-bg-fill);
  box-shadow: ${themeStyle.shadowMedium};
  width: 100%;
  padding: 24px 0px;

  ${QUERIES.largeTabletAndUp} {
    width: 336px;
    padding: 24px 32px;
  }
`;

export const PromoCodeWrapper = styled(FlexColumn)`
  input {
    width: 100%;
  }
`;

export const TosParagraph = styled(P4)`
  width: 100%;
`;
